export const NOT_INFORMED = 'NOT_INFORMED';
export const SIMPLE_PACKAGING = 'SIMPLE_PACKAGING';
export const NO_PACKAGING = 'NO_PACKAGING';
